//import './thesaurus-term-tree.scss'

import { ReactiveVue } from "@skinsoft/reactive-vue";
import Component from "vue-class-component";
import { Watch } from 'vue-property-decorator';
import { ThesaurusTerm, ThesaurusTermDataStore, thesaurusTermSelectors } from '@skinsoft/entity'
import { getTranslatedString } from '../localized-string';
import _ from 'lodash';
import ThesaurusTermTreeModal from "./thesaurus-term-tree-modal"

@Component({
    components: {
        sThesaurusTermTreeModal: ThesaurusTermTreeModal,
    },
    props: ['thesaurusIdentifier', 'startValue', 'placeholder'],
    template: require('./thesaurus-term-tree.html')
})
export default class ThesaurusTermTree extends ReactiveVue {
    private thesaurusIdentifier: string
    private startValue: string
    private placeholder: string

    // @ts-ignore
    private startThesaurusTerm: ThesaurusTerm | null = null
    private $thesaurusTermDataStore: ThesaurusTermDataStore

    public $refs: {
        modal: ThesaurusTermTreeModal,
    }

    private mounted() {
        if(this.startValue) {
            this.$thesaurusTermDataStore.fetchOne(this.startValue).subscribe(thesaurusTerm => {
                if(thesaurusTerm && thesaurusTerm.id) {
                    this.startThesaurusTerm = thesaurusTerm
                }
            })
        }
    }

    private getThesaurusTermTitle(thesaurusTerm: ThesaurusTerm) {
        return getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), this.$i18n.locale)
    }

    private get startThesaurusTermTitle(): string {
        if(this.startThesaurusTerm) {
            return this.getThesaurusTermTitle(this.startThesaurusTerm)
        }
        return ''
    }

    private openModal() {
        this.$refs.modal.openModal()
    }

    @Watch('startValue')
    private onStartValueChanged() {
        if(this.startValue) {
            this.$thesaurusTermDataStore.fetchOne(this.startValue).subscribe(thesaurusTerm => {
                if(thesaurusTerm && thesaurusTerm.id) {
                    this.startThesaurusTerm = thesaurusTerm
                }
            })
        } else {
            this.startThesaurusTerm = null
        }
    }
}